import { apiClient } from './client';

export interface PlanPrice {
    id: string;
    amount: number;
    currency: string;
    interval: 'month' | 'year';
    billing_interval?: 'month' | 'year';
    offer?: string;
    trialDays?: number;
    isDefault?: boolean;
}

export interface Plan {
    id: string;
    name: string;
    description: string;
    slogan?: string;
    isHighlighted?: boolean;
    highlightText?: string;
    displayOrder?: number;
    features: string[];
    prices: PlanPrice[];
}

export interface Region {
    code: string;
    name: string;
    currency: string;
}

export interface PlansResponse {
    success: boolean;
    data: Plan[];
    meta: {
        requestedCountry: string;
        shownCountry: string;
        shownCurrency: string;
        availableRegions: Region[];
        currencyLocked?: boolean;
        lockedCurrency?: string | null;
    };
}


export const plansService = {
    /**
     * Fetch plans with regional pricing.
     * @param countryOverride - Optional 2-letter country code to override auto-detection
     */
    getPlans: async (countryOverride?: string): Promise<PlansResponse> => {
        const params = new URLSearchParams();
        if (countryOverride) params.append('country', countryOverride);

        const response = await apiClient.get<PlansResponse>(`/plans?${params.toString()}`);
        return response.data;
    },
};
